import React, { useState, useEffect } from "react";
import { Table,Button } from "react-bootstrap";
import {
  useGetAllInvoicesByIdQuery,
  useGetDispatchAllDocumentsQuery,
  useGetDeliveryAllDocumentsQuery,
} from "./ProcurementApiSlice";
const ViewInvoice2 = ({ procCode, invoice, FullList }) => {
  const { data: invoiceAll } = useGetAllInvoicesByIdQuery(procCode);
  const [generatedInvoices, setGeneratedInvoices] = useState([]);
  const [updatedList, setUpdatedList] = useState([]);
  const [updatedListBuyer, setupdatedListBuyer] = useState([]);
  useEffect(() => {
    if (invoiceAll) {
      setGeneratedInvoices(invoiceAll?.data);
    }
    const updatedList = FullList?.all_media?.filter(
      (item) =>
        item.pattern === "Payment Sheet" &&
        item.entity_type === "Procurement Admin"
    );
    setUpdatedList(updatedList);
    const updatedListBuyer = FullList?.all_media?.filter(
      (item) => item.entity_type === "Buyer" && item.file_extension === "pdf"
    );
    setupdatedListBuyer(updatedListBuyer);
  }, [invoiceAll, FullList]);
  // let procCode=FullList.trade_procCode
  const { data: AddResponse } = useGetDispatchAllDocumentsQuery(procCode, {
    skip: !procCode,
  });
  const {
    data: AddResponseDelivery,
  } = useGetDeliveryAllDocumentsQuery(procCode, { skip: !procCode });

  const [dispatchData, setDispatchRecords] = useState([]);
  const [deliveryData, setdelivery] = useState([]);
  useEffect(() => {
    if (AddResponse !== undefined) {
      setDispatchRecords(AddResponse?.data);
    }
    if (AddResponseDelivery !== undefined) {
      setdelivery(AddResponseDelivery?.data);
    }
  }, [AddResponse, AddResponseDelivery]);
  const handleDownload = (fileUrl) => {
    if (fileUrl && fileUrl.includes(invoice)) {
      window.open(fileUrl, "_blank");
    }
  };

  const handleViewPdf = (url) => {
    window.open(url, "_blank");
  };
  const handleGenerateContractNote = (data) => {
    const filteredData = FullList?.all_media.filter(
      (item) => item.pattern === "Contract Note"
    );
    if (filteredData.length > 0) {
      const anchor = document.createElement("a");
      anchor.href = filteredData[0].file;
      anchor.download = `Contract_Note.${filteredData[0].file_extension}`;
      anchor.target = "_blank";
      anchor.click();
    } else {
      console.error('No invoices matching pattern "B2S" found.');
    }
  };
  return (
    <div className="p-2">
      {generatedInvoices?.length > 0 ? (
        <div>
          <h4>Generated Invoices & Contract Note</h4>
          <Table
            border="1"
            striped
            hover
            style={{ width: "100%", marginTop: "10px" }}
          >
            <thead>
              <tr>
                {/* <th>Invoice </th> */}
                <th> Invoice </th>
                <th> Location </th>

                <th>View Invoice</th>
                <th>Contract Note</th>

              </tr>
            </thead>
            <tbody>
              {generatedInvoices?.map((field, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{field.stock_location}</td>

                    {/* <td>{field?.stock_location?.address}, {field?.stock_location?.district}, {field?.stock_location?.state}</td> */}

                    <td>
                      {field?.invoice_documents
                        ?.filter((item) => item.file.includes(invoice))
                        ?.map((item) => (
                          <div key={item.id}>
                            <a
                              href={item.file}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Document
                            </a>
                          </div>
                        ))}
                    </td>
                    <td> <Button
  className="buttonOrangeDefaultColor"
      size="sm"
      onClick={() => handleGenerateContractNote(FullList)}
    >
        Contract Note <i class="mdi mdi-download"></i>
        </Button></td>

                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        ""
      )}
      <div>
        {updatedList?.length > 0 ? (
          <div>
            <h4>Payment Sheet</h4>
            <Table
              border="1"
              striped
              hover
              style={{ width: "100%", marginTop: "10px" }}
            >
              <thead>
                <tr>
                  <th>Created By</th>
                  <th>Document Type</th>
                  <th>View Document</th>
                </tr>
              </thead>
              <tbody>
                {FullList?.all_media?.map((record) => {
                  if (
                    record.pattern === "Payment Sheet" &&
                    record.entity_type === "Procurement Admin"
                  ) {
                    return (
                      <tr>
                        <td>{record.entity_type}</td>
                        <td>{record.pattern}</td>
                        <td>
                          <a
                            href={record.file}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          ""
        )}
      </div>

      {dispatchData?.map((dispatch) => (
        <div key={dispatch.id}>
          <h4>Dispatch Records</h4>
          <Table
            border="1"
            striped
            hover
            style={{ width: "100%", marginTop: "10px" }}
          >
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Stock Location</th>
                <th>Document Type</th>
                <th>View Document</th>
              </tr>
            </thead>
            <tbody>
              {dispatch?.dispatch_records?.map((record) => {
                const documentsLength = record.documents.length;
                return record.documents.map((document, index) => (
                  <tr key={document.id}>
                    {index === 0 && (
                      <td rowSpan={documentsLength}>{record.quantity} {FullList?.unit_of_measure}</td>
                    )}
                    <td>
                      {record?.stock_location?.address},
                      {record?.stock_location?.district}
                    </td>
                    <td>{document.pattern}</td>
                    <td>
                      <a
                        href={document.file}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Document
                      </a>
                    </td>
                  </tr>
                ));
              })}
            </tbody>
          </Table>
        </div>
      ))}

      {deliveryData?.map((dispatch) => (
        <div key={dispatch.id}>
          <h4>Delivery Records</h4>
          <Table
            border="1"
            striped
            hover
            style={{ width: "100%", marginTop: "10px" }}
          >
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Document Type</th>
                <th>View Document</th>
              </tr>
            </thead>
            <tbody>
              {dispatch?.delivery_details?.map((record) => {
                const documentsLength = record.documents.length;
                return record.documents.map((document, index) => (
                  <tr key={document.id}>
                    {index === 0 && (
                      <td rowSpan={documentsLength}>{record.quantity} {FullList?.unit_of_measure}</td>
                    )}
                    <td>{document.pattern}</td>
                    <td>
                      <a
                        href={document.file}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Document
                      </a>
                    </td>
                  </tr>
                ));
              })}
            </tbody>
          </Table>
        </div>
      ))}
    </div>
  );
};

export default ViewInvoice2;
